import { MutableRefObject, useEffect, useRef, useState } from "react";

type Size = {
  width: number;
  height: number;
};

export const useResizeObserver = (
  isDesktop: boolean,
): [MutableRefObject<HTMLDivElement | null>, Size] => {
  const observedElementRef = useRef<HTMLDivElement | null>(null);
  const [size, setSize] = useState<Size>({ width: 0, height: 0 });

  useEffect(() => {
    const observedElement = observedElementRef.current;

    if (!observedElement || !isDesktop) return;

    const resizeObserver = new ResizeObserver((entries) => {
      for (const entry of entries) {
        if (entry.target === observedElement) {
          setSize({
            width: entry.contentRect.width,
            height: entry.contentRect.height,
          });
        }
      }
    });

    resizeObserver.observe(observedElement);

    return () => {
      resizeObserver.unobserve(observedElement);
    };
  }, [isDesktop]);

  return [observedElementRef, size];
};
